import { useState } from 'react';
import type { ComprobanteResumen } from '../../types/comprobante';
import { reportarErrorInesperado } from '../../utils/reportarErrorInesperado';
import { abrirPdfEnPestanaNueva } from './abrirComprobante';
import { ComprobanteVisor } from './ComprobanteVisor';
import { EstadoComprobanteBadge } from './EstadoComprobanteBadge';

interface ComprobanteSoloLecturaProps {
  readonly etiqueta: string;
  /** Nulo: se registró antes de que el comprobante fuera obligatorio. */
  readonly comprobante: ComprobanteResumen | null;
  /** Lo que se lee cuando no hay comprobante, por ejemplo "Sin comprobante de origen en marcha blanca". */
  readonly textoSinComprobante: string;
}

/** Comprobante que se mira y no se cambia desde aquí: una imagen en el visor, un PDF en pestaña nueva. */
export const ComprobanteSoloLectura: React.FC<ComprobanteSoloLecturaProps> = ({ etiqueta, comprobante, textoSinComprobante }) => {
  const [visor, setVisor] = useState<ComprobanteResumen | null>(null);

  const ver = (c: ComprobanteResumen) => {
    if (c.tipo_archivo === 'pdf') {
      abrirPdfEnPestanaNueva(c).catch((e: unknown) => { reportarErrorInesperado(e, 'No pudimos abrir el comprobante'); });
      return;
    }
    setVisor(c);
  };

  if (!comprobante) return <span className="text-xs text-slate-400">{textoSinComprobante}</span>;

  return (
    <>
      <EstadoComprobanteBadge etiqueta={etiqueta} estado={{ tipo: 'adjunto', comprobante }} ahora={new Date()} onVer={ver} />
      {visor && <ComprobanteVisor comprobante={visor} onClose={() => { setVisor(null); }} />}
    </>
  );
};
